<template>
  <div class="modal-footer">
    <slot />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ModalFooter extends Vue {}
</script>

<style scoped>
.modal-footer {
  background-color: #f3f2f2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ddd;
  padding: 0 26px;
  flex: 0 0 73px;
  border-radius: 0 0 5px 5px;
}
</style>
